import {Dispatch} from 'react'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import {KEYS} from '../../constants/keysStorage'
import {generalShowLoader} from '../general.actions'
import {
  ResultadoRevisionVerificacion,
  VerificacionDato,
} from '../../interfaces/verificacion-datos.interface'

const MENSAJE_ERROR_REVISION =
  'No se logró marcar el registro como revisado. Intente de nuevo en unos minutos.'

const MENSAJE_REVISION_EXITOSA = 'El registro quedó marcado como revisado.'

const LARGO_MAXIMO_OBSERVACION = 500

const enMinusculas = (fila: any): any => {
  const salida: any = {}
  Object.keys(fila ?? {}).forEach((llave) => {
    salida[`${llave}`.toLowerCase()] = fila[llave]
  })
  return salida
}

const esVerdadero = (valor: any): boolean => {
  if (typeof valor === 'string') {
    const texto = valor.trim().toLowerCase()
    return texto === 'true' || texto === 't' || texto === '1'
  }
  if (typeof valor === 'number') return valor === 1
  return valor === true
}

const textoDe = (valor: any): string => (valor === null || valor === undefined ? '' : `${valor}`)

export const normalizarVerificacion = (fila: any): VerificacionDato => {
  const datos = enMinusculas(fila)
  return {
    idverificaciondato: Number(datos.idverificaciondato ?? 0),
    tipoentidad: textoDe(datos.tipoentidad).toUpperCase(),
    identidad: Number(datos.identidad ?? 0),
    codigoempresa: textoDe(datos.codigoempresa),
    nombre: textoDe(datos.nombre),
    documento: textoDe(datos.documento),
    codigomotivo: textoDe(datos.codigomotivo).toUpperCase(),
    titulo: textoDe(datos.titulo),
    mensaje: textoDe(datos.mensaje),
    querevisar: textoDe(datos.querevisar),
    detalle: textoDe(datos.detalle),
    pendiente: datos.pendiente === undefined ? true : esVerdadero(datos.pendiente),
    fechadeteccion: textoDe(datos.fechadeteccion),
    fecharevision: textoDe(datos.fecharevision),
    usuariorevision: textoDe(datos.usuariorevision),
    observacionrevision: textoDe(datos.observacionrevision),
    versionhacienda: textoDe(datos.versionhacienda),
  }
}

export const normalizarListaVerificaciones = (respuesta: any): Array<VerificacionDato> => {
  const contenido = respuesta?.data ?? respuesta
  const filas = Array.isArray(contenido) ? contenido : contenido?.verificaciones ?? []
  return (Array.isArray(filas) ? filas : []).map(normalizarVerificacion)
}

export const verificacionGetPendientes =
  (tipoentidad: string, identidad: number | null = null) =>
  async (): Promise<Array<VerificacionDato>> => {
    const parametros: any = {tipoentidad}
    if (identidad) parametros.identidad = identidad

    return await http
      .get(ENDPOINTS.NORMATIVA_GET_VERIFICACION_DATOS, parametros, KEYS.TOKEN)
      .then((res: any) => normalizarListaVerificaciones(res))
      .catch(() => [])
  }

export const verificacionMarcarRevisado =
  (
    tipoentidad: string,
    identidad: number,
    codigomotivo: string | null = null,
    observacion: string = ''
  ) =>
  async (dispatch: Dispatch<any>): Promise<ResultadoRevisionVerificacion> => {
    dispatch(generalShowLoader(true))

    const detalle = observacion.trim().substring(0, LARGO_MAXIMO_OBSERVACION)
    const cuerpo: any = {tipoentidad, identidad}
    if (codigomotivo) cuerpo.codigomotivo = codigomotivo
    if (detalle) cuerpo.observacion = detalle

    return await http
      .post(ENDPOINTS.NORMATIVA_POST_VERIFICACION_REVISADO, cuerpo, {}, KEYS.TOKEN)
      .then((res: any) => ({
        exitoso: true,
        mensaje: res?.message ?? MENSAJE_REVISION_EXITOSA,
      }))
      .catch((err: any) => ({
        exitoso: false,
        mensaje: err?.response?.data?.message ?? MENSAJE_ERROR_REVISION,
      }))
      .finally(() => dispatch(generalShowLoader(false)))
  }
